import { useAppSelector } from '../../redux/hooks';
import { bootstrapTimezoneSelector } from '../../redux/selectors/bootstrap';
import moment from 'moment';

const useSyndicateTimezoneLabel = () => {
  const syndicateTimeZone = useAppSelector(bootstrapTimezoneSelector);
  return moment.tz(syndicateTimeZone).format('z');
};

export default useSyndicateTimezoneLabel;
